import React from "react";

import API from "../../base/API";

export default class InlineForm extends React.Component {

    constructor(props) {
        super(props);

        this.api = new API({
            update_field: "/test/update/field/:test"
        });

        this.state = {
            value: this.props.value === null ? "" : this.props.value,
            oldValue: "",
            isEditing: false
        }
    }

    onSave() {
        this.api.request({
            cache: false,
            route: "update_field",
            data: { field: this.props.field, value: this.state.value },
            params: { test: this.props.test },
            success: (response) => {
                if(typeof this.props.onSuccess !== "undefined") {
                    this.props.onSuccess(this.state.value, this.state.oldValue);
                }
                this.setState({ isEditing: false });
                window.dispatchEvent(new Event("reloadLog"));
            }
        });
    }

    onChange(evt) {
        this.setState({ value: evt.target.value });
    }

    onCancel() {
        this.setState({ isEditing: false, value: this.state.oldValue })
    }

    onEdit() {
        if(this.props.readonly === true) {
            return;
        }
        this.setState({ isEditing: true, oldValue: this.state.value });
    }

    renderSelect() {
        return (
            <div className="row">
                <div className="col-sm-12 col-md-6">
                    <div className="input-group input-group-sm">

                        <select value={this.state.value}
                            onChange={this.onChange.bind(this)}
                            className="form-control">
                            {this.props.options.map((option, index) => {
                                return <option value={option.value} key={index}>{option.text}</option>;
                            })}
                        </select>

                        <span className="input-group-btn">
                            <button className="btn btn-success" onClick={this.onSave.bind(this)}>
                                <i className="fa fa-save" />
                            </button>
                            <button className="btn btn-primary" onClick={this.onCancel.bind(this)}>
                                <i className="fa fa-close" />
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        )
    }

    renderInput() {
        return (
            <div className="row">
                <div className="col-sm-12 col-md-6">
                    <div className="input-group input-group-sm">
                        <input type="text" value={this.state.value} onChange={this.onChange.bind(this)} className="form-control" />
                        <span className="input-group-btn">
                            <button className="btn btn-success" onClick={this.onSave.bind(this)}>
                                <i className="fa fa-save" />
                            </button>
                            <button className="btn btn-primary" onClick={this.onCancel.bind(this)}>
                                <i className="fa fa-close" />
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        )
    }

    render() {

        if (!this.state.isEditing) {

            let value = this.state.value;
            
            if(this.props.type === "select") {
                const option = this.props.options.find((option) => option.value === this.state.value);
                value = typeof option !== "undefined" ? option.text : "";
            }

            value = value ? value : "-----";

            return (
                <span onClick={this.onEdit.bind(this)}>
                    {this.props.readonly !== true ? <span><i className="fa fa-edit" />  </span> : ""}
                    {value} {typeof this.props.suffix !== "undefined" ? this.props.suffix : ""}
                </span>
            )
        }

        return this.props.type === "select" ? this.renderSelect() : this.renderInput();
    }
}


// WEBPACK FOOTER //
// ./src/modules/test/parts/InlineForm.jsx